import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {Utils} from "../../../shared/utils/utils";
import {DbTextPipe} from "../../../shared/pipes/db-text.pipe";
import {NgClass} from "@angular/common";
import {LoadingBarComponent} from "../../../shared/components/loading-bar/loading-bar.component";

@Component({
    selector: 'db-password-validation',
    templateUrl: './password-validation.component.html',
    styleUrls: ['./password-validation.component.scss'],
    imports: [
        DbTextPipe,
        NgClass,
        LoadingBarComponent
    ]
})
export class PasswordValidationComponent implements OnChanges{
  @Input() isMobile?: boolean = false;
  @Input() showOnTop?: boolean = false;
  @Input() formGroup: FormGroup;
  public progress: number = 0;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup'] && this.formGroup) {
      this.updateProgress();
      this.formGroup.get('password')?.valueChanges.subscribe(() => this.updateProgress());
    }
  }

  private updateProgress() {
    const passwordControl = this.formGroup.get('password') as FormControl;
    if (passwordControl) {
      this.progress = Utils.progressPercent(passwordControl);
    }
  }
}
